/** Access token só em memória; refresh em sessionStorage (aba). */

const REFRESH_KEY = "evolua.auth.refresh";
const CHALLENGE_KEY = "evolua.auth.challenge";

export type StoredChallenge = {
  email: string;
  session: string;
  challengeName: string;
};

let accessToken: string | null = null;
let idToken: string | null = null;
/** Epoch ms when access token should be considered expired. */
let accessExpiresAt = 0;

export function getAccessToken(): string | null {
  return accessToken;
}

export function getIdToken(): string | null {
  return idToken;
}

export function getAccessExpiresAt(): number {
  return accessExpiresAt;
}

export function setTokens(bundle: {
  accessToken: string;
  idToken: string;
  refreshToken?: string;
  expiresIn: number;
}): void {
  accessToken = bundle.accessToken;
  idToken = bundle.idToken;
  accessExpiresAt = Date.now() + Math.max(bundle.expiresIn - 5, 1) * 1000;
  if (bundle.refreshToken) {
    try {
      sessionStorage.setItem(REFRESH_KEY, bundle.refreshToken);
    } catch {
      /* private mode / quota */
    }
  }
}

export function clearTokens(): void {
  accessToken = null;
  idToken = null;
  accessExpiresAt = 0;
  try {
    sessionStorage.removeItem(REFRESH_KEY);
  } catch {
    /* ignore */
  }
}

export function getRefreshToken(): string | null {
  try {
    return sessionStorage.getItem(REFRESH_KEY);
  } catch {
    return null;
  }
}

export function setChallenge(challenge: StoredChallenge): void {
  try {
    sessionStorage.setItem(CHALLENGE_KEY, JSON.stringify(challenge));
  } catch {
    /* ignore */
  }
}

export function getChallenge(): StoredChallenge | null {
  try {
    const raw = sessionStorage.getItem(CHALLENGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredChallenge;
    if (!parsed?.email || !parsed?.session || !parsed?.challengeName) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearChallenge(): void {
  try {
    sessionStorage.removeItem(CHALLENGE_KEY);
  } catch {
    /* ignore */
  }
}
